import { EuiBadge } from "@inscopix/ideas-eui";

interface FileTagProps {
  tag: string;
}
export const FileTag = ({ tag }: FileTagProps) => {
  return <EuiBadge color="hollow">{tag}</EuiBadge>;
};
